//Gets the import rows that don't include the header row, if the header checkbox is checked
function getImportDataRows(vm) {
  if (!Array.isArray(vm.importRows)) {
    throw Error("vm.importRows should be an array");
  }
  var newImportRows = vm.importRows;
  if (vm.headerChecked) {
    newImportRows = vm.importRows.slice(1); //Don't include first element of array (the header row)
  }
  return newImportRows;
}

module.exports = getImportDataRows;



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/vm-helpers/getImportDataRows.js